CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Sticker = require 'models/sticker'
_ = require 'underscore'

module.exports = class StickerList extends CollectionWithHelpers
  model: Sticker
  url: -> "/1/cards/#{ @card.get('id') }/stickers"

  initialize: (list, { @card }) ->
    @listenTo @, 'change:zIndex', @sort
    return

  comparator: (sticker) -> sticker.get('zIndex') || 0

  nextZIndex: (model) ->
    if @length > 0
      currentMax = _.max(@pluck('zIndex'))

      # If the specified model is already at the max, and nothing else is
      # return the current max
      if (model?.get('zIndex') == currentMax &&
          @filter((s) -> s.get('zIndex') == currentMax).length == 1)
        currentMax
      else
        currentMax + 1

    else
      1



// WEBPACK FOOTER //
// ./app/scripts/models/collections/sticker-list.coffee